import PropTypes from 'prop-types';

import { Vertical } from './layouts/Vertical';

// Função auxiliar para mapear arquivos
const mapFileField = (patched, person, fieldName, urlName) => {
  if (patched[fieldName]?.download) return;

  const hasData = person[fieldName]?.data;
  const hasUrl = person[urlName];
  const hasFile = person.files?.[fieldName];

  if (hasData || hasUrl || hasFile) {
    patched[fieldName] = hasData
      ? { ...person[fieldName], download: person[fieldName].data }
      : person.files?.[fieldName] || { download: person[urlName] };
  }
};

const adaptPerson = (person) => {
  if (!person) return person;
  const patched = { ...person };

  // Mapear variantes de listagem para campos usados pelos componentes
  mapFileField(patched, person, 'file', 'url_curriculo');
  mapFileField(patched, person, 'pessoa_historico_agenda');
  mapFileField(patched, person, 'pessoa_historico_agenda_externa');
  if (!patched.substituto && person.substitutoPessoa) {
    const s = person.substitutoPessoa;
    // Só considera válido se tiver URL e algum título
    if (s?.url && (s.title || s.alt)) {
      patched.substituto = {
        '@id': s.url,
        title: s.title || s.alt,
        image: s.image,
      };
    }
  }
  // Garantir que imagens em formato string sejam objetos com download
  if (
    patched.substituto?.image &&
    typeof patched.substituto.image === 'string'
  ) {
    patched.substituto.image = { download: patched.substituto.image };
  }
  if (patched.image && typeof patched.image === 'string') {
    patched.image = { download: patched.image };
  }
  return patched;
};

const PersonCard = (props) => {
  const {
    cardSize = 'regular',
    person,
    showAllLinks = true,
    showSubstitute = true,
    isEditMode,
  } = props;
  const adaptedPerson = adaptPerson(person);
  const passProps = { ...props, person: adaptedPerson };

  return (
    <Vertical
      {...passProps}
      cardSize={cardSize}
      showAllLinks={showAllLinks}
      showSubstitute={showSubstitute}
      isEditMode={isEditMode}
    />
  );
};

PersonCard.propTypes = {
  person: PropTypes.shape({
    title: PropTypes.string,
    cargo: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    // Adicione outros campos conforme necessário
  }),
  showDescription: PropTypes.bool,
  hideName: PropTypes.bool,
  showLink: PropTypes.bool,
  // layout removido: apenas vertical suportado
  cardSize: PropTypes.oneOf(['regular', 'compact']),
  isEditMode: PropTypes.bool,
};

export default PersonCard;
